<template>
  <div id="app_wrapper">
    <div id="main_menu">
      <img src="@/assets/img/prometco-logo.png" id="logo" />

      <div class="menu_item" :class="{selected: current_section == 1}" @click="set_section(1)">
        <div class="menu_icon icon_01"></div>
        <p>Patient characteristics</p>
      </div>

      <div class="menu_item" :class="{selected: current_section == 2}" @click="set_section(2)">
        <div class="menu_icon icon_02"></div>
        <p>Efficacy outcome</p>
      </div>

      <div class="menu_item" :class="{selected: current_section == 3}" @click="set_section(3)">
        <div class="menu_icon icon_03"></div>
        <p>Conclusions</p>
      </div>
    </div>

    <div class="top_icon" :class="get_icon_class"></div>
    <div class="top_nav_wrapper" :class="{'conclusions' : current_animation == 'conclusions'}">
      <h1 v-if="current_animation == 'conclusions'">Conclusions</h1>
      <div class="top_nav" v-if="current_section == 1">
        <button :class="{selected: (current_animation == 'bc_age' || current_animation == 'bc_sex')}" @click="set_graph('bc_age')">Age and sex</button>
        <button :class="{selected: (current_animation == 'bc_ecog')}" @click="set_graph('bc_ecog')">ECOG PS</button>
        <button :class="{selected: (current_animation == 'bc_ras' || current_animation == 'bc_msi')}" @click="set_graph('bc_ras')">Biomolecular status</button>
        <button :class="{selected: (current_animation == 'bc_meta' || current_animation == 'bc_ds' || current_animation == 'bc_type')}" @click="set_graph('bc_meta')">Disease characteristics</button>
        <button :class="{selected: (current_animation == 'bc_prior' || current_animation == 'bc_prior_radio')}" @click="set_graph('bc_prior')">Prior treatment</button>
      </div>

      <div class="top_nav top_nav2" v-if="current_section == 2">
        <button :class="{selected: (current_animation == 'eff_os')}" @click="set_graph('eff_os')">OS from mCRC diagnosis</button>
        <button :class="{selected: (current_animation == 'eff_os3')}" @click="set_graph('eff_os3')">OS from third-line treatment</button>
        <button :class="{selected: (current_animation == 'eff_mos')}" @click="set_graph('eff_mos')">mOS and mPFS</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_age' || current_animation == 'bc_sex')">
        <button :class="{selected: current_animation == 'bc_age'}" @click="set_graph('bc_age')">Age</button>
        <button :class="{selected: current_animation == 'bc_sex'}" @click="set_graph('bc_sex')">Sex</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_ras' || current_animation == 'bc_msi')">
        <button :class="{selected: current_animation == 'bc_ras'}" @click="set_graph('bc_ras')"><em>RAS/BRAF</em></button>
        <button :class="{selected: current_animation == 'bc_msi'}" @click="set_graph('bc_msi')">MSI/MSS</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_meta' || current_animation == 'bc_ds' || current_animation == 'bc_type')">
        <button :class="{selected: current_animation == 'bc_meta'}" @click="set_graph('bc_meta')">Metastatic site location</button>
        <button :class="{selected: current_animation == 'bc_ds'}" @click="set_graph('bc_ds')">Disease sidedness</button>
        <button :class="{selected: current_animation == 'bc_type'}" @click="set_graph('bc_type')">Type of metastasis</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_prior' || current_animation == 'bc_prior_radio')">
        <button :class="{selected: current_animation == 'bc_prior'}" @click="set_graph('bc_prior')">Prior surgery</button>
        <button :class="{selected: current_animation == 'bc_prior_radio'}" @click="set_graph('bc_prior_radio')">Prior radiotherapy</button>
      </div>
    </div>

    <div id="main_content">
      
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_age/images/" :loop="false" :animationData="bc_age_JSON" :width="980" :height="520" v-if="current_animation == 'bc_age'" autoPlay="true" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_sex/images/" :loop="false" :animationData="bc_sex_JSON" :width="980" :height="520" v-if="current_animation == 'bc_sex'" autoPlay="true" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_ecog/images/" :loop="false" :animationData="bc_ecog_JSON" :width="980" :height="520" v-if="current_animation == 'bc_ecog'" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_ras/images/" :loop="false" :animationData="bc_ras_JSON" :width="980" :height="520" v-if="current_animation == 'bc_ras'" :autoPlay="false" ref="bc_ras" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_msi/images/" :loop="false" :animationData="bc_msi_JSON" :width="980" :height="520" v-if="current_animation == 'bc_msi'" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_meta/images/" :loop="false" :animationData="bc_meta_JSON" :width="980" :height="520" v-if="current_animation == 'bc_meta'" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_ds/images/" :loop="false" :animationData="bc_ds_JSON" :width="980" :height="520" v-if="current_animation == 'bc_ds'" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_type/images/" :loop="false" :animationData="bc_type_JSON" :width="980" :height="520" v-if="current_animation == 'bc_type'" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_prior/images/" :loop="false" :animationData="bc_prior_JSON" :width="980" :height="520" v-if="current_animation == 'bc_prior'" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/bc_prior_radio/images/" :loop="false" :animationData="bc_prior_radio_JSON" :width="980" :height="520" v-if="current_animation == 'bc_prior_radio'" />

      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/eff_os/images/" :loop="false" :animationData="eff_os_JSON" :width="980" :height="520" v-if="current_animation == 'eff_os'" ref="eff_os" :autoPlay="false" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/eff_os3/images/" :loop="false" :animationData="eff_os3_JSON" :width="980" :height="520" v-if="current_animation == 'eff_os3'" ref="eff_os3" :autoPlay="false" />
      <Vue3Lottie assetsPath="https://www.prometco.fr/anim2024/graphs/eff_mos/images/" :loop="false" :animationData="eff_mos_JSON" :width="980" :height="520" v-if="current_animation == 'eff_mos'" ref="eff_mos" :autoPlay="false" />
      
      <img src="https://www.prometco.fr/anim2024/conclusions.png" width="980" style="position: absolute; left: 0px; top: 0px;" v-if="current_animation == 'conclusions'" />

      <!--<Vue3Lottie assetsPath="./graphs/graph_02/images/" :loop="false" :animationData="graph_02_JSON" :width="980" :height="520" v-if="gIndex == 2" />
      <Vue3Lottie assetsPath="graphs/graph_13/images/" :autoPlay="false" :loop="false" @onEnterFrame="enterFrame" @onComplete="animComplete" :animationData="graph_13_JSON" :width="980" :height="520" v-if="gIndex == 2" ref="interactive_1" />
      <Vue3Lottie assetsPath="graphs/graph_14/images/" :autoPlay="false" :loop="false" @onEnterFrame="enterFrame" @onComplete="animComplete" :animationData="graph_14_JSON" :width="980" :height="520" v-if="gIndex == 1" ref="interactive_2" />-->

      <div class="interactive_1_btns" v-if="current_animation == 'eff_os'">
        <div class="iBtn" id="iBtn1" @click="int_click(1, 1)" v-if="!int_1_conc_shown"></div>
        <div class="iBtn" id="iBtn2" @click="int_click(1, 2)" v-if="!int_1_conc_shown"></div>
        <div class="iBtn" id="iBtn3" @click="int_click(1, 3)" v-if="!int_1_conc_shown"></div>
        <div class="iBtn" id="iBtn4" @click="int_click(1, 4)" v-if="!int_1_conc_shown"></div>
        <div class="iBtn" id="iBtn5" @click="int_click(1, 5)" v-if="!int_1_conc_shown"></div>
        <div class="iBtn" id="iBtn6" @click="int_click(1, 6)" v-if="!int_1_conc_shown"></div>

        <div class="cBtn" id="cBtn1" @click="int_click(1, 7)" v-if="!int_1_conc_shown"></div>
        <div class="cBtn" id="cBtn2" @click="int_click(1, 8)" v-if="int_1_conc_shown"></div>
        <div class="cBtn" id="cBtn3" @click="int_click(1, 9)" v-if="int_1_conc_shown"></div>
      </div>


      <div class="interactive_1_btns" v-if="current_animation == 'eff_os3'">
        <div class="iBtn" id="iBtn1" @click="int_click(2, 1)" v-if="!int_2_conc_shown"></div>
        <div class="iBtn" id="iBtn2" @click="int_click(2, 2)" v-if="!int_2_conc_shown"></div>
        <div class="iBtn" id="iBtn3" @click="int_click(2, 3)" v-if="!int_2_conc_shown"></div>
        <div class="iBtn" id="iBtn4" @click="int_click(2, 4)" v-if="!int_2_conc_shown"></div>
        <div class="iBtn" id="iBtn5" @click="int_click(2, 5)" v-if="!int_2_conc_shown"></div>
        <div class="iBtn" id="iBtn6" @click="int_click(2, 6)" v-if="!int_2_conc_shown"></div>

        <div class="cBtn" id="cBtn1" @click="int_click(2, 7)" v-if="!int_2_conc_shown"></div>
        <div class="cBtn" id="cBtn2" @click="int_click(2, 8)" v-if="int_2_conc_shown"></div>
        <div class="cBtn" id="cBtn3" @click="int_click(2, 9)" v-if="int_2_conc_shown"></div>
      </div>

      <div class="interactive_1_btns" v-if="current_animation == 'eff_mos'">

        <div class="cBtn" id="cBtn1b" @click="int_click(3, 1)" v-if="!int_3_conc_shown"></div>
        <div class="cBtn" id="cBtn2b" @click="int_click(3, 2)" v-if="int_3_conc_shown"></div>
        <div class="cBtn" id="cBtn3b" @click="int_click(3, 3)" v-if="int_3_conc_shown"></div>
      </div>
      
      <div class="interactive_1_btns" v-if="current_animation == 'bc_ras'">
        <div class="cBtn" id="cBtn4" @click="play_bc_ras_end()"></div>
      </div>
    </div>
    

    <div id="footer">
      <div class="servier_logo"></div>
      <p>Overall and progression-free survival of patients with metastatic colorectal cancer: A real-world prospective, longitudinal cohort study on the continuum of care (PROMETCO)</p>
    </div>
  </div>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie'

import bc_age_JSON from '@/assets/graphs/bc_age/data.json'
import bc_sex_JSON from '@/assets/graphs/bc_sex/data.json'
import bc_ecog_JSON from '@/assets/graphs/bc_ecog/data.json'
import bc_ras_JSON from '@/assets/graphs/bc_ras/data.json'
import bc_msi_JSON from '@/assets/graphs/bc_msi/data.json'
import bc_meta_JSON from '@/assets/graphs/bc_meta/data.json'
import bc_ds_JSON from '@/assets/graphs/bc_ds/data.json'
import bc_type_JSON from '@/assets/graphs/bc_type/data.json'
import bc_prior_JSON from '@/assets/graphs/bc_prior/data.json'
import bc_prior_radio_JSON from '@/assets/graphs/bc_prior_radio/data.json'
import eff_os_JSON from '@/assets/graphs/eff_os/data.json'
import eff_os3_JSON from '@/assets/graphs/eff_os3/data.json'
import eff_mos_JSON from '@/assets/graphs/eff_mos/data.json'

export default {
  name: 'App',
  components: {
    Vue3Lottie
  },
  mounted()
  {
    /*window.addEventListener('set_section', (e) => {
      alert(JSON.stringify(e));
    });*/

    window.addEventListener('message', this.receiveMessage, false);
  },
  methods:
  {
    receiveMessage(event) {
      if (event.type == "message" && event.data.set_section != undefined)
      {
        console.log(event.data.set_section);
        this.set_section(event.data.set_section);
        //console.log(event.type);
      }
      
      //alert(JSON.stringify(event));
    },
    enterFrame()
    {
      //console.log(this.$refs.interactive_1.getCurrentFrame());
    },
    animComplete()
    {
      
    },
    set_section_from_html(event)
    {
      alert(JSON.stringify(event));
      this.set_section(event.index);
    },
    set_section(index)
    {
      this.current_section = index;

      if (index == 1)
      {
        this.set_graph('bc_age');
      }
      else if (index == 2)
      {
        this.set_graph('eff_os');
      }
      else if (index == 3)
      {
        this.set_graph('conclusions');
      }
    },
    startInteractive(index)
    {
      if (index == 1)
      {
        this.$refs.eff_os.playSegments([0, 257], true);
      }

      if (index == 2)
      {
        this.$refs.eff_os3.playSegments([0, 270], true);
      }

      if (index == 3)
      {
        this.$refs.eff_mos.playSegments([0, 195], true);
      }
    },
    set_graph(graph_index)
    {
      this.current_animation = graph_index;

      if (graph_index == 'eff_os')
      {
        this.int_1_conc_shown = false;
          setTimeout(() => {
            this.startInteractive(1);
          }, 500);
      }
      if (graph_index == 'eff_os3')
      {
        this.int_2_conc_shown = false;
          setTimeout(() => {
            this.startInteractive(2);
          }, 500);
      }
      if (graph_index == 'eff_mos')
      {
        this.int_2_conc_shown = false;
          setTimeout(() => {
            this.startInteractive(3);
          }, 500);
      }

      if (graph_index == "bc_ras")
      {
        setTimeout(() => {
          this.$refs.bc_ras.playSegments([0, 239], true);
          }, 500);
        
      }
    },
    play_bc_ras_end()
    {
      this.$refs.bc_ras.playSegments([243, 245], true);
    },
    int_click(int_index, btn_index)
    {
      if (int_index == 1)
      {
        if (btn_index == 1)
        {
          this.$refs.eff_os.playSegments([270, 285], true);
        }
        if (btn_index == 2)
        {
          this.$refs.eff_os.playSegments([310, 325], true);
        }
        if (btn_index == 3)
        {
          this.$refs.eff_os.playSegments([335, 350], true);
        }
        if (btn_index == 4)
        {
          this.$refs.eff_os.playSegments([360, 375], true);
        }
        if (btn_index == 5)
        {
          this.$refs.eff_os.playSegments([385, 400], true);
        }
        if (btn_index == 6)
        {
          this.$refs.eff_os.playSegments([410, 425], true);
        }


        if (btn_index == 7)
        {
          this.$refs.eff_os.playSegments([513, 519], true);
          this.int_1_conc_shown = true;
        }
        if (btn_index == 8)
        {
          this.$refs.eff_os.playSegments([445, 446], true);
        }
        if (btn_index == 9)
        {
          this.$refs.eff_os.playSegments([486, 487], true);
        }
      }

      if (int_index == 2)
      {
        if (btn_index == 1)
        {
          this.$refs.eff_os3.playSegments([270, 280], true);
        }
        if (btn_index == 2)
        {
          this.$refs.eff_os3.playSegments([300, 320], true);
        }
        if (btn_index == 3)
        {
          this.$refs.eff_os3.playSegments([340, 355], true);
        }
        if (btn_index == 4)
        {
          this.$refs.eff_os3.playSegments([370, 385], true);
        }
        if (btn_index == 5)
        {
          this.$refs.eff_os3.playSegments([410, 425], true);
        }
        if (btn_index == 6)
        {
          this.$refs.eff_os3.playSegments([440, 450], true);
        }


        if (btn_index == 7)
        {
          this.$refs.eff_os3.playSegments([499, 512], true);
          this.int_2_conc_shown = true;
        }
        if (btn_index == 8)
        {
          this.$refs.eff_os3.playSegments([518, 519], true);
        }
        if (btn_index == 9)
        {
          this.$refs.eff_os3.playSegments([534, 536], true);
        }
      }

      if (int_index == 3)
      {
        if (btn_index == 1)
        {
          this.$refs.eff_mos.playSegments([210, 212], true);
          this.int_3_conc_shown = true;
        }
        if (btn_index == 2)
        {
          this.$refs.eff_mos.playSegments([241, 243], true);
        }
        if (btn_index == 3)
        {
          this.$refs.eff_mos.playSegments([300, 302], true);
        }
      }
    }
    
  },
  computed:
  {
    get_icon_class()
    {
      switch (this.current_animation)
      {
        case 'bc_age':
          return 'nav_icon_01';
        case 'bc_sex':
          return 'nav_icon_02';
        case 'bc_ecog':
          return 'nav_icon_03';
        case 'bc_ras':
          return 'nav_icon_04';
        case 'bc_msi':
          return 'nav_icon_04';
        case 'bc_meta':
          return 'nav_icon_05';
        case 'bc_ds':
          return 'nav_icon_05';
        case 'bc_type':
          return 'nav_icon_05';

        case 'bc_prior':
          return 'nav_icon_06';
        case 'bc_prior_radio':
          return 'nav_icon_06';
        
        case 'eff_os':
          return 'nav_icon_07';  

        case 'eff_os3':
          return 'nav_icon_08';  

        case 'eff_mos':
          return 'nav_icon_09';  

        default:

        return 'icon_1';
      }
      
    }
  },
  data() {
    return {
      bc_age_JSON,
      bc_sex_JSON,
      bc_ecog_JSON,
      bc_ras_JSON,
      bc_msi_JSON,
      bc_meta_JSON,
      bc_ds_JSON,
      bc_type_JSON,
      bc_prior_JSON,
      bc_prior_radio_JSON,
      eff_os_JSON,
      eff_os3_JSON,
      eff_mos_JSON,
      current_animation: "bc_age",
      int_1_conc_shown: false,
      int_2_conc_shown: false,
      int_3_conc_shown: false,
      current_section: 1
    }
  },
}
</script>

<style>

@import "./css/style.css";

</style>
